export default (src) => {
    return new Promise((resolve, reject) => {
        let s;
        s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
}


// WEBPACK FOOTER //
// ./src/utils/load_script.js